
import {
  Component,
  Mixins,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/org';
import pageMixin from '@/views/Home/mixins/pageMixin';

@Component({
  components: {
    Pagination,
  },
})
export default class Account extends Mixins(pageMixin) {
  @State(state => state.org.curCompRefresh) curCompRefresh!: boolean;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleCloseRerfesh!: Function;

  private loading: Boolean = true;

  private tList: any = [];

  @Prop({
    required: true,
  }) chargeType!: string;

  private column: Array<ITABLECOLCONF> = [
    {
      label: '试卷名称',
      prop: 'paperName',
      align: 'center',
      tooltip: true,
    },
    {
      label: '试卷描述',
      prop: 'paperDescription',
      align: 'center',
      tooltip: true,
      width: '350px',
    },
    {
      label: '状态',
      custom: true,
      prop: 'statusTag',
      align: 'center',
      width: '100px',
      tags: [{
        value: '0',
        type: 'warning',
        label: '已停用',
      }, {
        value: '1',
        type: 'success',
        label: '已启用',
      }],
    },
    {
      label: '创建时间',
      align: 'center',
      prop: 'createTime',
      minWidth: '100px',
      width: '200px',
      tooltip: true,
    },
    {
      label: '操作',
      custom: true,
      minWidth: '80',
      align: 'center',
      maxBtn: 2,
      btnList: [
        {
          title: '删除',
          name: '/org/operate/paper:update',
          icon: 'remove',
          type: 'info',
          callback: this.handleRemovePaper,
          log: {
            name: '机构信息 - 课包记录 - 编辑',
            component: 'org/operate/table/course',
          },
        },
        {
          title: '停用',
          name: '/org/operate/paper:status',
          icon: 'shield',
          type: 'info',
          handleType: (row: any) => {
            switch (row.statusTag) {
              case 0: return 'success';
              case 1: return 'warning';
              default: return 'warning';
            }
          },
          handleTitle: (row: any) => {
            switch (row.statusTag) {
              case 1: return '停用';
              case 0: return '启用';
              default: return '启用';
            }
          },
          callback: this.handlePaperStatus,
          log: {
            name: '机构信息 - 课包记录 - 启用/停用',
            component: 'org/operate/table/course',
          },
        },
      ],
    },
  ];

  mounted() {
    this.getData();
  }

  getData() {
    this.loading = true;
    const pid: string = Base64.decode(this.$route.params.pid || '');
    api.getOrgPaperList(this.page, pid).then((res: any) => {
      this.tList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  // 删除记录列表
  handleRemovePaper(row: any) {
    this.confirm('你确认删除该试卷列表吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removePaperList(row.pid).then(() => {
        close();
        this.getData();
        this.$log({
          title: '机构管理 - 课包停用/启用 - 确定',
          component: 'org/manage/course',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 课包停用/启用 - 取消',
      component: 'org/manage/course',
    }));
  }

  /**
   * @author liangyongmou
   * @description 改变课包状态
   * @param { any } row 行数据
   */
  handlePaperStatus(row: any) {
    this.confirm('你确认进行该操作吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      let status = 0;
      if (row.statusTag === 0) status = 1;
      else if (row.statusTag === 1) status = 0;
      const data = {
        pid: row.pid,
        orgPid: Base64.decode(this.$route.params.pid || ''),
        statusTag: status,
      }
      api.togglePaperStatus(data).then(() => {
        close();
        this.getData();
        this.$log({
          title: '机构管理 - 课包停用/启用 - 确定',
          component: 'org/manage/course',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 课包停用/启用 - 取消',
      component: 'org/manage/course',
    }));
  }

  @Watch('curCompRefresh')
  handlePageRefrsh(v: boolean) {
    if (v) {
      this.handleCloseRerfesh(false);
      this.page.pageNo = 1;
      this.getData();
    }
  }


  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
